const roles = {
    roleList: [],
    loadingRoles: true,
    roleTableData: [],
    newRoleList: [],
    selectedPermissions: {},
    currentPermissions: [],
    permissionsDDL: [],
    selectedRoles: {},
    currentRolesForUser: [],
    rolesDDL: [],
    currentRolePermissions: [],
    selectedEditRoleDetails: {},
    currentGroupsListApp: [],
    currentSelectedGroup: {},
    selectedMembers: [],
    selectedMembersIds: [],
    allMembersData: {},
    currentMembers: [],
    appSettingsData: [],
    parentsGroupSelected: [],
    appGroupsInitialData: [],
    refreshData: null,
    paginatedGroupsList: [], // used in groups interface
    permissionsRolesGroupSelected: {} // PERMISSISONS: permissions roles - admin - edit group (Direct && Inherited Permissions) // new Permissions System
};

export default roles;
